import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import debounce from 'lodash.debounce';
var currentEle = null;
var page_name = '';
var page_section = '';
var capitalize = function capitalize() {
  var word = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return word.replace(/\b[a-z,-]/g, function (matched) {
    return matched === '-' ? ' ' : matched.toUpperCase();
  });
};

/**
 * Retrieves metadata from meta tags on the current page.
 * @returns {Object} An object containing metadata extracted from meta tags.
 */
export var pageMeta = function pageMeta() {
  var exports = {};

  // If running in a non-browser environment, return an empty object
  if (typeof window === 'undefined') {
    return exports;
  }
  var meta = document.querySelectorAll('meta');
  var metaSet = Array.prototype.slice.call(meta);

  // iterate over all the meta tags assigning them to exports.
  metaSet.forEach(function (meta) {
    var key = meta.getAttribute('name') || meta.getAttribute('property');
    if (key) {
      var overrideKey = 'bam-override-' + key + '=';
      var overrideIndex = window.location.href.indexOf(overrideKey);
      if (overrideIndex !== -1) {
        var overrideVal = window.location.href.substr(overrideIndex + overrideKey.length);
        var nextAmp = overrideVal.indexOf('&');
        if (nextAmp !== -1) {
          overrideVal = overrideVal.substr(0, nextAmp);
        }
        exports[key] = overrideVal;
      } else {
        exports[key] = meta.getAttribute('content');
      }

      // If the data-type attribute is 'json', parse the metadata value as JSON
      if (meta.getAttribute('data-type') === 'json') {
        exports[key] = JSON.parse(exports[key]);
      }
    }
  });
  return exports;
};
var init = function init() {
  page_name = pageMeta().page_name;
  page_section = pageMeta().page_section;
};
export var makeTrackingCall = function makeTrackingCall(prop14) {
  var prop12 = 'Navigation Module';
  var prop13 = "".concat(page_name, ": ").concat(capitalize(page_section));
  var awsAsyncTracking = window.trackAsync;
  var jspAsyncTracking = window.bam && window.bam.tracking && window.bam.tracking.track;
  var groovyAsyncTracking = window.Curveball && window.Curveball.MobileTracking && window.Curveball.MobileTracking.fireAsync;

  //MLB AWS
  if (awsAsyncTracking) {
    awsAsyncTracking({
      prop12: prop12,
      prop13: prop13,
      prop14: prop14
    });
  }
  //MLB JSP http://mlb.mlb.com
  //cannot overwrite prop13 on JSP sites
  //http://mlb.mlb.com/shared/scripts/bam.tracking.js
  if (jspAsyncTracking) {
    jspAsyncTracking({
      async: {
        compName: prop12,
        compActivity: prop14
      }
    });
  }
  //MLB GROOVY http://m.mlb.com
  //cannot overwrite prop13 on m.mlb.com sites
  // http://ui.bamstatic.com/curveball-builds/bundles/Curveball-MLBGlobal.js
  // https://wiki.mlbam.com/display/omniture/Omniture+Variable+Mapping
  if (groovyAsyncTracking) {
    groovyAsyncTracking({
      dynamic_component: prop12,
      dynamic_componentAction: prop14
    });
  }
};
export var makeFieldPassTracking = function makeFieldPassTracking(_ref) {
  var trackingType = _ref.trackingType;
  return function (_ref2) {
    var _window$adobeAnalytic;
    var action = _ref2.action,
      payload = _ref2.payload,
      type = _ref2.type;
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object' || typeof window.trackPageView !== 'function' || typeof window.trackAsync !== 'function') {
      return;
    }
    var _ref3 = payload || {},
      elementType = _ref3.elementType,
      source = _ref3.source,
      status = _ref3.status;
    var pageViewTracking = window.firePageView || window.trackPageView;
    var originalPageName = ((_window$adobeAnalytic = window.adobeAnalytics) === null || _window$adobeAnalytic === void 0 ? void 0 : _window$adobeAnalytic.pageName) || 'Major League Baseball: Homepage';
    var pageName = window.adobeAnalytics.pageName = "".concat(originalPageName, ": FieldPass Modal: ").concat(source);
    if (type === 'page-load') {
      pageViewTracking({
        pageName: pageName
      });
    } else if (type === 'click') {
      var clickTrackingData = {
        prop12: trackingType,
        prop13: pageName
      };
      switch (action) {
        case 'fieldpass':
          clickTrackingData = _objectSpread(_objectSpread({}, clickTrackingData), {}, {
            prop14: "".concat(pageName, ": ").concat(elementType, " Click")
          });
          break;
        case 'fieldpass-login-register':
          clickTrackingData = _objectSpread(_objectSpread({}, clickTrackingData), {}, {
            prop14: "".concat(source, " ").concat(status)
          });
          break;
        case 'fieldpass-close':
          clickTrackingData = _objectSpread(_objectSpread({}, clickTrackingData), {}, {
            prop14: "".concat(source, ": close ").concat(elementType)
          });
          break;
        // TODO: Confirm if prop14 value is correct as whole payload
        default:
          clickTrackingData = _objectSpread(_objectSpread({}, clickTrackingData), {}, {
            prop14: payload
          });
      }
      window.trackAsync(clickTrackingData);
    }
    window.adobeAnalytics.pageName = originalPageName;
  };
};
export var getScrWidth = function getScrWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};
export var trackOnHover = function trackOnHover(e) {
  var type = 'top';
  var isHoverable = true;
  if (e.target.classList.contains('header__nav-side__nav-item')) {
    type = 'side';
  }
  var target = e.target.querySelector(".header__nav-".concat(type, "__nav-item__link"));
  if (getScrWidth() < 1024 && type === 'top') {
    isHoverable = false;
  }
  if (!target || currentEle === target) {
    currentEle = null;
    return;
  }
  var navSubParent = target.textContent;
  var prop14 = "Navigation Module: ".concat(type === 'side' ? 'Sidebar' : 'Topbar', ": ").concat(navSubParent, ": Hover Open");
  if (isHoverable) {
    makeTrackingCall(prop14);
  }
  e.stopPropagation();
};
export var makeHoverCall = debounce(trackOnHover, 700);
var cancelHoverCall = debounce(function (e) {
  currentEle = e.target.querySelector('.header__nav-top__nav-item__link');
}, 201);
var callMLBLogoTracking = function callMLBLogoTracking() {
  var mlbLogo = document.querySelector('.header__nav-top__logo a');
  mlbLogo && mlbLogo.addEventListener('click', function () {
    var prop14 = 'Navigation Module: MLB Logo Click';
    makeTrackingCall(prop14);
  });
};
var callMLBAccountTracking = function callMLBAccountTracking() {
  var mlbAccount = document.querySelector('.header__nav-top__button.account');
  mlbAccount && mlbAccount.addEventListener('click', function () {
    var prop14 = 'Navigation Module: Topbar: Account Click';
    makeTrackingCall(prop14);
  });
};
var callNavItemsTracking = function callNavItemsTracking() {
  var navItems = document.querySelectorAll('.header__nav-top__nav-item a.header__nav-top__nav-item__link, .header__nav-side__nav-item:not([aria-haspopup]) a.header__nav-side__nav-item__link');
  var topNav = document.querySelector('.header__nav-top');
  var sideNav = document.querySelector('.header__nav-side');
  navItems = [].slice.call(navItems);
  navItems.forEach(function (navItem) {
    var navPos = '';
    if (topNav && topNav.contains(navItem)) {
      navPos = 'Topbar: ';
    } else if (sideNav && sideNav.contains(navItem)) {
      navPos = 'Sidebar: ';
    }
    navItem.addEventListener('click', function () {
      var prop14 = "Navigation Module: ".concat(navPos).concat(navItem.textContent);
      makeTrackingCall(prop14);
    });
  });
};
var callNavHoverIntentTracking = function callNavHoverIntentTracking() {
  var hdrNavsItems = document.querySelectorAll('.header__nav-side__nav-item, .header__nav-top__nav-item');
  var topNav = document.querySelector('.header__nav-top');
  hdrNavsItems = [].slice.call(hdrNavsItems);
  hdrNavsItems.forEach(function (hdrNavsItem) {
    if (hdrNavsItem.getAttribute('aria-haspopup') === 'true') {
      hdrNavsItem.addEventListener('mouseenter', makeHoverCall);
      if (topNav && topNav.contains(hdrNavsItem)) {
        hdrNavsItem.addEventListener('mouseleave', cancelHoverCall);
      }
    }
  });
};
export var addTracking = function addTracking() {
  if (typeof window === 'undefined') {
    return;
  }
  init();
  callMLBLogoTracking();
  callMLBAccountTracking();
  callNavItemsTracking();
  callNavHoverIntentTracking();
};